var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _circle2, _circle3, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSite2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0060_mind_map",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    "data-imageid": "mind-map-86",
    imageName: "Mind Map",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_mind-map-86{opacity:.18;}.cls-1_mind-map-86,.cls-2_mind-map-86{isolation:isolate;}.cls-1_mind-map-86,.cls-2_mind-map-86,.cls-3_mind-map-86,.cls-4_mind-map-86,.cls-5_mind-map-86,.cls-6_mind-map-86,.cls-7_mind-map-86,.cls-8_mind-map-86,.cls-9_mind-map-86,.cls-10_mind-map-86,.cls-11_mind-map-86,.cls-12_mind-map-86,.cls-13_mind-map-86,.cls-14_mind-map-86{stroke-width:0px;}.cls-1_mind-map-86,.cls-14_mind-map-86{fill:#68e1fd;}.cls-2_mind-map-86{fill:url(#linear-gradient);opacity:.19;}.cls-3_mind-map-86{fill:url(#linear-gradient-4-mind-map-86);}.cls-4_mind-map-86{fill:url(#linear-gradient-2-mind-map-86);}.cls-5_mind-map-86{fill:url(#linear-gradient-3-mind-map-86);}.cls-6_mind-map-86{fill:url(#linear-gradient-8-mind-map-86);}.cls-7_mind-map-86{fill:url(#linear-gradient-9-mind-map-86);}.cls-8_mind-map-86{fill:url(#linear-gradient-7-mind-map-86);}.cls-9_mind-map-86{fill:url(#linear-gradient-5-mind-map-86);}.cls-10_mind-map-86{fill:url(#linear-gradient-6-mind-map-86);}.cls-11_mind-map-86{fill:#231f20;}.cls-12_mind-map-86{fill:#fff;}.cls-13_mind-map-86{fill:#ffaa71;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-mind-map-86",
    x1: 301.38,
    y1: -676.62,
    x2: 390.86,
    y2: -676.62,
    gradientTransform: "translate(-167.86 940.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-mind-map-86",
    x1: 434.09,
    y1: -912.92,
    x2: 436.87,
    y2: -809.31,
    gradientTransform: "translate(-167.86 940.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fff",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fff",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-mind-map-86",
    x1: 116.5,
    y1: -907.27,
    x2: 116.97,
    y2: -885.41,
    gradientTransform: "translate(-31 940.47)",
    xlinkHref: "#linear-gradient-2-mind-map-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-mind-map-86",
    x1: 131.53,
    y1: -907.6,
    x2: 132,
    y2: -885.74,
    gradientTransform: "translate(-31 940.47)",
    xlinkHref: "#linear-gradient-2-mind-map-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5-mind-map-86",
    x1: 146.55,
    y1: -907.93,
    x2: 147.03,
    y2: -886.07,
    gradientTransform: "translate(-31 940.47)",
    xlinkHref: "#linear-gradient-2-mind-map-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6-mind-map-86",
    x1: 328.19,
    y1: -516.68,
    x2: 343.46,
    y2: -424.61,
    gradientTransform: "translate(-167.86 940.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#000",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7-mind-map-86",
    x1: 357.54,
    y1: -521.55,
    x2: 372.81,
    y2: -429.48,
    xlinkHref: "#linear-gradient-6-mind-map-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8-mind-map-86",
    x1: 331.29,
    y1: -505.48,
    x2: 335.02,
    y2: -426.81,
    xlinkHref: "#linear-gradient-6-mind-map-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9-mind-map-86",
    x1: 361.32,
    y1: -506.9,
    x2: 365.06,
    y2: -428.23,
    xlinkHref: "#linear-gradient-6-mind-map-86"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "background_mind-map-86",
    className: "cls-1_mind-map-86 targetColor",
    d: "M464.16,260.63c18.95-24.26,27.69-54.96,24.38-85.56-1.91-16.81-7.84-33.7-19.74-45.73-23.23-23.5-61.11-22.35-91.16-36.08-28.36-12.91-48.63-38.67-74.42-56.15-39.5-26.8-97.34-30.95-132.87.92-11.94,10.73-20.61,24.59-30.84,36.95-12.84,15.54-28.19,28.83-45.41,39.31-13.14,8-27.59,14.52-38.08,25.79-6.47,6.93-11.11,15.38-15.1,23.99-11.37,24.6-17.94,51.96-14.83,78.89,3.11,26.93,16.77,53.29,39.31,68.25,6.3,4.19,13.47,7.73,17.45,14.16,5.9,9.56,2.76,21.79.89,32.87-3.1,18.43-3.16,41.5,4.27,59.09,4.14,9.77,7.68,13.7,12.63,15.16,0,0,0,0,0,0-.94.67,35.64,19.95,100.93,15.4,6.94-.47,19.37-5.9,26.29-6.63,8.9-.87,17.91-.44,26.77-1.59,8.85-1.15,17.89-4.18,23.95-10.69,14.08-3.73,86.41,1.74,116.69-12.76,17.7-8.48,29.62-27.81,29.25-47.43-.23-13.65-5.9-26.92-5.09-40.55,1.65-27.54,27.62-45.97,44.72-67.61Z",
    style: {
      fill: "rgb(61, 127, 250)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shadow_mind-map-86",
    className: "cls-2_mind-map-86",
    d: "M142.14,301.94c-3.93-4.54-8.91-9.26-8.61-15.27.23-4.44,3.35-8.12,6.32-11.43l6.98-7.78,9.35-10.4c2.26-2.67,4.76-5.13,7.46-7.35.75-.5,1.41-1.11,1.96-1.82.33-.52.59-1.07.78-1.66,2.97-8.21,4.52-16.88,4.58-25.61,0-2.13,0-4.49,1.45-6.04,1.01-1.08,2.52-1.5,3.94-1.88,3.13-.82,6.35-1.59,9.58-1.41,3.23.18,6.54,1.45,8.53,4.01,2.36,3.07,2.38,7.27,2.3,11.13-.08,3.86-10.78,9.34-10.85,13.17,0,1,7.31,1.16,8.24,1.54,4.86,2.04,7.68,10.4,8.13,11.17,7.5,12.65,10.59,16.39,18.09,29.04,1.17,1.97,2.37,4.03,2.58,6.32s-.61,4.6-1.53,6.74c-3.03,7.03-7.24,13.49-12.43,19.12-.75.92-1.69,1.66-2.76,2.18-3,1.24-6.46-1.06-9.6-.27,3.09-6.84,11.23-11,12.55-18.39.73-4.19-1.01-8.53-3.73-11.83-2.72-3.29-6.29-5.71-9.82-8.1-.92,6.36-1.83,12.73-2.76,19.09-.73,5.03-1.45,10.14-.76,15.19.24,1.8.44,4.08-1.13,4.96-.64.28-1.33.41-2.03.36-10.32.1-20.64-.12-30.95-.68-3.41-.19-5.86,0-8.1-2.73-2.9-3.53-4.73-7.88-7.78-11.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "screen_mind-map-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14_mind-map-86 targetColor",
    x: 69.04,
    y: 40.97,
    width: 396.23,
    height: 275.2,
    rx: 18.07,
    ry: 18.07,
    style: {
      fill: "rgb(61, 127, 250)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4_mind-map-86",
    d: "M465.24,59.05v5.9H69.05v-5.9c0-9.98,8.09-18.07,18.07-18.09h360.06c9.98.02,18.06,8.11,18.06,18.09Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5_mind-map-86",
    cx: 85.94,
    cy: 53.68,
    r: 4.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M287.98,125.98h-93.15v-48.37h93.15v48.37ZM197.64,123.17h87.53v-42.74h-87.53v42.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M172.63,178.13h-80.93v-48.36h80.93v48.36ZM94.51,175.32h75.31v-42.74h-75.31v42.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M430.23,138.65h-80.93v-48.37h80.93v48.37ZM352.11,135.84h75.31v-42.74h-75.31v42.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M309.75,258.78h-99.82v-53.43h99.82v53.43ZM212.74,255.96h94.19v-47.81h-94.19v47.81Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M427.26,229.15h-79.16v-53.43h79.16v53.43ZM350.92,226.33h73.53v-47.8h-73.53v47.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M333.17,179.97h-114.79v-37.83h114.79v37.83ZM221.19,177.16h109.17v-32.2h-109.17v32.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_mind-map-86",
    x: 245.45,
    y: 122.22,
    width: 2.81,
    height: 24.44,
    transform: "translate(-31.73 171.89) rotate(-36.23)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_mind-map-86",
    x: 171.22,
    y: 154.67,
    width: 48.56,
    height: 2.81
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_mind-map-86",
    x: 300.42,
    y: 126.63,
    width: 54,
    height: 2.81,
    transform: "translate(-14.11 211.43) rotate(-35.08)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_mind-map-86",
    x: 328.15,
    y: 168.32,
    width: 2.81,
    height: 44.37,
    transform: "translate(-8.31 365.85) rotate(-57.46)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12_mind-map-86",
    x: 244.05,
    y: 191.25,
    width: 30.57,
    height: 2.81,
    transform: "translate(-18.69 357.2) rotate(-67.23)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3_mind-map-86",
    cx: 100.98,
    cy: 53.68,
    r: 4.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9_mind-map-86",
    cx: 116.01,
    cy: 53.68,
    r: 4.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "character_mind-map-86"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_mind-map-86",
    d: "M179.45,212.34c.67,3.7,1.09,7.45,1.25,11.21.14,1.4.06,2.82-.25,4.2-.32,1.4-1.27,2.57-2.57,3.18-.79.32-1.71.34-2.41.81-.57.42-.97,1.02-1.14,1.71-.23,1.3-.23,2.63,0,3.93.2,1.31-.09,2.66-.81,3.77-.65.71-1.5,1.22-2.44,1.45-2.21.69-4.56.79-6.82.28-.36-.05-.7-.2-1-.41-.31-.31-.53-.69-.64-1.11-.82-2.52-1.49-5.09-1.99-7.69-.79-3.63-1.61-7.35-1.69-11.1-.07-3.75.68-7.62,2.78-10.72,2.11-3.1,5.74-5.31,9.45-5.09,2.08.25,4.11.87,5.98,1.82,1.56.71,1.93,2.06,2.29,3.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11_mind-map-86",
    d: "M179.45,207.2c.1-1.87-1.37-3.42-2.86-4.54-.28-.18-.52-.41-.73-.68-.21-.42-.36-.85-.47-1.31-.6-1.69-2.62-2.45-4.42-2.45s-3.57.55-5.36.49c-1.45,0-2.91-.43-4.23.17-.74.41-1.38.99-1.86,1.69-.9,1.04-1.53,2.29-1.82,3.63-.11.6-.1,1.21-.25,1.8-.2.66-.53,1.28-.96,1.82-1.88,2.57-4.61,4.73-5.28,7.84-.42,1.97-.85,4.24.1,6.01,9.15,17.08,11.47,18.07,12.41,17.94s6.14-.38,6.68-6.91c.12-.44.17-.9.13-1.36-.14-.36-.36-.69-.65-.95-.65-.63-1.18-1.37-1.58-2.18-.42-.83-.42-1.81,0-2.64.73-1.07,2.19-1.35,3.26-.63,0,0,0,0,0,0,.16.11.3.24.43.38.61-1.74-1.2-3.71-.46-5.41.45-1.03,1.7-1.53,2.14-2.57.57-1.37-.45-3.29.64-4.3.37-.26.76-.48,1.16-.67.62-.38.73-.89,1.05-1.49s.39-.55,1.05-.89c1.09-.53,1.81-1.6,1.89-2.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14_mind-map-86 targetColor",
    d: "M162.55,241.35s-12.99,3.16-14.75,7.38c-1.76,4.22-15.99,17.4-15.64,22.64.36,5.24,10.13,11.89,10.13,11.89l7.47-7.27,3.51,56.54s14.23,3.63,25.27,0c11.04-3.63,12.93-6.35,12.93-6.35l-1.9-52.26,8.98,11.7,11.92-10.26s-17.59-28.66-20.59-30.41c-3-1.74-16.41-3.77-16.41-3.77,0,0-5.93,3.58-10.93.18Z",
    style: {
      fill: "rgb(61, 127, 250)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_mind-map-86",
    d: "M162.55,241.35s-12.99,3.16-14.75,7.38c-1.76,4.22-15.99,17.4-15.64,22.64.36,5.24,10.13,11.89,10.13,11.89l7.47-7.27,3.51,56.54s14.23,3.63,25.27,0c11.04-3.63,12.93-6.35,12.93-6.35l-1.9-52.26,8.98,11.7,11.92-10.26s-17.59-28.66-20.59-30.41c-3-1.74-16.41-3.77-16.41-3.77,0,0-5.93,3.58-10.93.18Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_mind-map-86",
    d: "M132.19,271.36s-9.32,12.63-9.57,14.71c-.25,2.08,25.2,32.83,25.2,32.83,0,0,1.92,6.86,5.09,7.83l-1.01-16.46s-13.9-23.02-15.58-22.66l4.92-5.15s-7.92-5.47-9.06-11.1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_mind-map-86",
    d: "M198.52,285.6l3.47,4.89-11.04,22.24s-3.95,2.01-4.16,3.85c-.21,1.84,4.3,0,4.3,0l.35,9.59s4.86-5.31,7.08-9.59c2.22-4.28,15.27-23.26,15.83-25.62,1.05-4.22-6.24-13.62-6.24-13.62l-9.59,8.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11_mind-map-86",
    d: "M153.28,332.51v102.5h11.81l5.4-78.29,4.74-.87,8.45,79.12h9.18l-1.41-108.78s-15.43,5.37-38.17,6.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14_mind-map-86 targetColor",
    d: "M175.34,446.88c0,.22,0,.44-.05.66,0,0-17.32,1.79-20.17.52s-2.65-2.01-2.65-2.01l.8-11.09h11.81c8.47,1.29,10.05,7.19,10.28,10.42v.07c.03.47.02.94-.02,1.41Z",
    style: {
      fill: "rgb(61, 127, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14_mind-map-86 targetColor",
    d: "M183.38,434.97l-.73,11.09s-.21.73,2.65,2.01c2.86,1.28,20.17-.52,20.17-.52,0,0,1.56-10.77-10.24-12.57h-11.84Z",
    style: {
      fill: "rgb(61, 127, 250)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10_mind-map-86",
    d: "M175.34,446.88c0,.22,0,.44-.05.66,0,0-17.32,1.79-20.17.52s-2.65-2.01-2.65-2.01l.8-11.09h11.81c8.47,1.29,10.05,7.19,10.28,10.42v.07c.03.47.02.94-.02,1.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8_mind-map-86",
    d: "M183.38,434.97l-.73,11.09s-.21.73,2.65,2.01c2.86,1.28,20.17-.52,20.17-.52,0,0,1.56-10.77-10.24-12.57h-11.84Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_mind-map-86",
    d: "M175.34,446.88c0,.22,0,.44-.05.66,0,0-17.32,1.79-20.17.52s-2.65-2.01-2.65-2.01l.8-11.09,6-.15v.15l-.28.95s-1.58,6.65,0,8.45c1.58,1.8,16.07,1.05,16.41,1.03h0v.07l-.06,1.41Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7_mind-map-86",
    d: "M205.49,446.88c0,.22,0,.44-.05.66,0,0-17.32,1.79-20.17.52s-2.64-2.01-2.64-2.01l.73-11.08,6-.15-.04.15-.28.95s-1.58,6.65,0,8.45c1.58,1.8,16.07,1.05,16.41,1.03h0v1.45l.04.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite2);
export default __webpack_public_path__ + "static/media/site2.3f10e29096c099089a2c6d8f27daa572.svg";
export { ForwardRef as ReactComponent };